import { render, staticRenderFns } from "./body weight entry lotwise.vue?vue&type=template&id=1aa5ffd8&"
import script from "./body weight entry lotwise.vue?vue&type=script&lang=js&"
export * from "./body weight entry lotwise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports